import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import {
  TranslationFeedbackTypeEnum,
  TranslationFeedback,
} from '../../../../graphql/service/graphql-auto-main-service';
import { LotTranslationsFeedbackModalComponent } from '../lot-translations-feedback-modal/lot-translations-feedback-modal.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TranslateService } from '@ngx-translate/core';
import { LotTranslationsFeedbackService } from '../../services/lot-translations-feedback.service';
import { ObservableLoadings } from '../../../../../const';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-lot-translations-feedback',
  templateUrl: './lot-translations-feedback.component.html',
  styleUrls: ['./lot-translations-feedback.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotTranslationsFeedbackComponent {
  @Input() isManager = false;
  @Input() translationId!: string;
  @Input() likesCount = 0;
  @Input() dislikesCount = 0;
  @Input() feedback: TranslationFeedback | null | undefined;

  @Output() completed = new EventEmitter<void>();

  readonly FeedbackTypeEnum = TranslationFeedbackTypeEnum;
  translationFeedbackDeleting$: ObservableLoadings = {};

  constructor(
    private modalService: NzModalService,
    private translate: TranslateService,
    private lotTranslationsFeedbackService: LotTranslationsFeedbackService,
  ) {}

  get isLikeActive(): boolean {
    return this.feedback?.feedbackType === TranslationFeedbackTypeEnum.Like;
  }

  get isDislikeActive(): boolean {
    return this.feedback?.feedbackType === TranslationFeedbackTypeEnum.Dislike;
  }

  openLotTranslationsFeedbackModal(type: TranslationFeedbackTypeEnum): void {
    if (this.feedback?.feedbackType === type) {
      this.translationFeedbackDeleting$[type] = this.lotTranslationsFeedbackService
        .deleteTranslationFeedback(this.feedback?.id)
        .pipe(finalize(() => this.completed.emit()));
      return;
    }

    this.modalService.create({
      nzTitle: this.translate.instant(
        type === 'like'
          ? 'LOT_TRANSLATION_FEEDBACK.LEAVE_FEEDBACK_LIKE'
          : 'LOT_TRANSLATION_FEEDBACK.LEAVE_FEEDBACK_DISLIKE',
      ),
      nzContent: LotTranslationsFeedbackModalComponent,
      nzWidth: '50%',
      nzComponentParams: {
        feedback: this.feedback,
        translationId: this.translationId,
        type,
        completed: this.completed,
      },
    });
  }
}
